export default "__VITE_ASSET__CqyQRJXM__"